/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCheckboxInput/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheck from 'DesignSystem/Svgs/TysiaCheck/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaCheckboxInput({
  children,
  viewPath = "/DesignSystem/TysiaCheckbox/TysiaCheckboxInput",
  alignSelf = "center",
  backgroundColor,
  marginTop,
  width = 20,
  height = 20,
  value,
  hovered,
  disabled,
  invalid,
  size
  
}) {
let dtTysiacheckboxinputBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.backgroundColor.primary.base'
        })
let dtTysiacheckboxinputBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.base'
        })
let dtTysiacheckboxinputBackgroundcolorPrimaryValue = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.backgroundColor.primary.value'
        })
let dtTysiacheckboxinputBordercolorPrimaryValue = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.value'
        })
let dtTysiacheckboxinputBordercolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.hovered'
        })
let dtTysiacheckboxinputBackgroundcolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.backgroundColor.primary.invalid'
        })
let dtTysiacheckboxinputBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.invalid'
        })
let backgroundColorOrdtTysiacheckboxinputBackgroundcolorPrimaryBase = backgroundColor ?? dtTysiacheckboxinputBackgroundcolorPrimaryBase
let dtTysiacheckboxinputFill2PrimaryValue = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.fill2.primary.value'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaCheckboxInput.Horizontal"
  data-view-path={viewPath}
 style={{'--as-1-Z1MJHT3': alignSelf,'--mt-4-Z1MJHT3': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--bc-2-Z1MJHT3': value ? dtTysiacheckboxinputBackgroundcolorPrimaryValue : invalid ? dtTysiacheckboxinputBackgroundcolorPrimaryInvalid : backgroundColorOrdtTysiacheckboxinputBackgroundcolorPrimaryBase,'--bc-3-Z1MJHT3': value ? dtTysiacheckboxinputBordercolorPrimaryValue : hovered ? dtTysiacheckboxinputBordercolorPrimaryHovered : invalid ? dtTysiacheckboxinputBordercolorPrimaryInvalid : dtTysiacheckboxinputBordercolorPrimaryBase,'--o-7-Z1MJHT3': disabled ? 0.25 : 1,'--w-5-Z1MJHT3': size === "small" ? "14px" : typeof width === 'number' ? `${width}px` : width,'--h-6-Z1MJHT3': size === "small" ? "14px" : typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheck
  viewPath={`${viewPath}/TysiaCheck`}
 width={size === "small" ? "12px" : "16px"}
 height={size === "small" ? "12px" : "16px"}
 opacity={value ? 1 : 0}
 fill2={dtTysiacheckboxinputFill2PrimaryValue}
/>
</div>
{children}
</React.Fragment>)
}